// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "38bf0c65" + "." + "1eebc5a9b3009cad" + ".js";
};